/* jshint esversion: 6 */

/**
 * Service pour gérer Google reCAPTCHA v3
 */
export default {
    /**
     * Charge le script reCAPTCHA si ce n'est pas déjà fait
     */
    loadScript() {
        return new Promise((resolve, reject) => {
            // Vérifier si le script est déjà chargé
            if (window.grecaptcha) {
                resolve();
                return;
            }

            const siteKey = process.env.RECAPTCHA_SITE_KEY;
            if (!siteKey) {
                console.warn('RECAPTCHA_SITE_KEY not configured');
                reject(new Error('reCAPTCHA not configured'));
                return;
            }

            const script = document.createElement('script');
            script.setAttribute(
                'src',
                `https://www.google.com/recaptcha/api.js?render=${siteKey}`
            );
            script.async = true;
            script.defer = true;

            script.onload = () => {
                resolve();
            };

            script.onerror = () => {
                reject(new Error('Failed to load reCAPTCHA script'));
            };

            document.head.appendChild(script);
        });
    },

    /**
     * Exécute reCAPTCHA et retourne un token
     * @param {string} action - L'action à enregistrer (ex: 'contact', 'login', 'submit')
     * @returns {Promise<string>} Le token reCAPTCHA
     */
    async execute(action = 'submit') {
        const siteKey = process.env.RECAPTCHA_SITE_KEY;
        
        if (!siteKey) {
            console.warn('RECAPTCHA_SITE_KEY not configured');
            return null;
        }

        try {
            await this.loadScript();

            return new Promise((resolve, reject) => {
                if (!window.grecaptcha) {
                    reject(new Error('grecaptcha not available'));
                    return;
                }

                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(siteKey, { action })
                        .then(token => {
                            resolve(token);
                        })
                        .catch(error => {
                            console.error('reCAPTCHA execution error:', error);
                            reject(error);
                        });
                });
            });
        } catch (error) {
            console.error('reCAPTCHA error:', error);
            throw error;
        }
    },

    /**
     * Vérifie si reCAPTCHA est configuré
     * @returns {boolean}
     */
    isConfigured() {
        return !!process.env.RECAPTCHA_SITE_KEY;
    }
};
